import { Icon } from '@antimatterhq/ui/components/icon';
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
} from '@antimatterhq/ui/components/card';
import { Button } from '@antimatterhq/ui/components/button';
import { Text } from '@antimatterhq/ui/components/typography';
import { useSetAtom } from 'jotai';
import { showRequestNewDatasourceDialogAtom } from '@/atoms/dataSources/dataSourcesAtoms';

export type RequestNewDatasourceCardProps = {
  'data-testid'?: string;
};

export const RequestNewDatasourceCard: React.FC<
  RequestNewDatasourceCardProps
> = ({ 'data-testid': dataTestId = 'request-new-datasource-card' }) => {
  const setShowDialog = useSetAtom(showRequestNewDatasourceDialogAtom);

  return (
    <>
      <Card
        className={'flex min-h-60 w-full flex-col px-4 py-4'}
        data-testid={dataTestId}
      >
        <CardHeader className="space-y-1 p-0">
          <Text
            size="lg"
            semiBold
            color="secondary"
            data-testid={`${dataTestId}-title`}
          >
            Looking for more?
          </Text>
        </CardHeader>

        <CardContent className="flex h-full w-full items-center justify-center">
          <Icon
            icon={'antimatterhq:custom-datasource'}
            className="mt-auto text-4xl text-blue-500"
            width={64}
            data-testid={`${dataTestId}-icon`}
          />
        </CardContent>

        <CardFooter className="mt-auto w-full px-0 py-0">
          <Button
            leftIcon="lucide:message-circle-question"
            className="w-full"
            onClick={() => setShowDialog(true)}
            data-testid={`${dataTestId}-button`}
          >
            Request a new datasource integration
          </Button>
        </CardFooter>
      </Card>
    </>
  );
};
